import { formatEquineAge } from './equineAge';
import { horseEnumLabel } from './horseEnumLabel';

/**
 * Construit le subtitle d'une carte cheval :
 *   "X ans · Type · Sexe · Localisation"
 *
 * Champs manquants skippés silencieusement (.filter(Boolean)).
 * Retourne null si tout est vide → permet à l'appelant de masquer la ligne.
 *
 * Séparateur : · (middle dot U+00B7), aligné sur le mobile.
 *
 * type / sex sont des enums fermés : affichés via horseEnumLabel (mapping i18n,
 * code DB inchangé). Util non-React → horseEnumLabel consomme l'i18n singleton.
 *
 * @param {object} horse
 * @returns {string|null}
 */
export function buildHorseSubtitle(horse) {
  if (!horse) return null;
  const parts = [
    formatEquineAge(horse.dateOfBirth),
    horseEnumLabel('type', horse.type),
    horseEnumLabel('sex', horse.sex),
    horse.location?.city,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : null;
}
